import axiosInstance from '../services/AxiosInstance';

export const getMerchantTransSettings = (getData) => {
  return axiosInstance.get("merchant-settings/list", {
    params: getData,
  });
};

export const getMerchantBankAccountCount = (getData) => {
  return axiosInstance.get("merchant-settings/details", {
    params: getData,
  });
};

export const addMerchantTransSettings = (data) => {
  return axiosInstance.post("merchant-settings/create", data);
};

export const updateMerchantTransSettings = (id, data) => {
  return axiosInstance.put(`merchant-settings/update/${id}`, data);
};

export const fetchMerchantTransSettingsById = async (id) => {
    const response = await axiosInstance.get(`merchant-settings/show/${id}`);
    return response.data;
};

export const fetchMerchantTransSettingsByUser = async (userId) => {
  const response = await axiosInstance.get(`merchant-settings/show-by-user/${userId}`);
  return response.data;
};